import { render } from "./DepartmentProjectManager.vue?vue&type=template&id=5d0208b4&scoped=true"
import script from "./DepartmentProjectManager.vue?vue&type=script&lang=js"
export * from "./DepartmentProjectManager.vue?vue&type=script&lang=js"

import "./DepartmentProjectManager.vue?vue&type=style&index=0&id=5d0208b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d0208b4"]])

export default __exports__